import { StylesConfig } from 'react-select';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import { Z_INDICES } from 'dashboard/styles/variables';
import Tooltip from 'design-system/components/Tooltip';

const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const NodeLimitTextWithTooltip = styled.span`
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;
  user-select: none;
`;

const reactSelectStyles: StylesConfig = {
  singleValue: (styles) => ({
    ...styles,
    color: '#0E0E11',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '125%',
  }),
  control: () => ({
    height: '32px',
  }),
  container: () => ({
    width: '82px',
  }),
};

const TOOLTIP_Z_INDEX = Z_INDICES.modal + 500;
const NODE_LIMIT_OPTIONS = ['10', '25', '50', '100', '500', '1000', '2000'];

const NodeLimit = ({
  nodeLimit,
  onChange,
}: {
  nodeLimit: number;
  onChange: (n: number) => void;
}) => {
  const onNodeLimitChange = (newNodeLimit: string) => {
    onChange(Number(newNodeLimit));
  };

  return (
    <Row>
      <div>
        <Tooltip
          iconTrigger={<NodeLimitTextWithTooltip>Node limit: </NodeLimitTextWithTooltip>}
          portal={true}
          side='top'
          zIndex={TOOLTIP_Z_INDEX}
        >
          The maximum number of nodes returned
          <br />
          in the initial results. A higher node limit
          <br />
          may extend the query loading time.
        </Tooltip>
      </div>
      <ReactSelect
        classNamePrefix='GraphEditorDropdown'
        value={nodeLimit.toString()}
        onChange={onNodeLimitChange}
        options={NODE_LIMIT_OPTIONS.map((numHops) => {
          return {
            label: numHops,
            value: numHops,
          };
        })}
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        styles={reactSelectStyles}
        portal
      />
    </Row>
  );
};

export default NodeLimit;
